import { Col } from 'antd';

const GridResumenGeneralContratoSIva = ({ budget, budget_not_iva, totalNoFiscal, advanceNoFiscal }) => {

    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const budgetNotIva = budget * (budget_not_iva / 100);

    return (
        <>
            <Col xs={24} md={12}>
                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Porcentaje:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            {numberFormat.format(budget_not_iva) || "0.00"} %
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Presup. Contrato 2 (sin IVA):
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(budgetNotIva) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Anticipo Contrato 2:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(advanceNoFiscal) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Total estimado Contrato 2:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(totalNoFiscal) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Saldo real Contrato 2:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(budgetNotIva- (advanceNoFiscal+totalNoFiscal)) || "0.00"}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </>
    )
}

export default GridResumenGeneralContratoSIva;